module.exports = __webpack_public_path__ + "img/cqt2.1f8a0db4.jpg";